export const environment = {
  production: false,
  apiBaseUri: "https://avid-api-dev.callrevu.com"
};
